<template>
  <div>
    <el-row>

      <el-col :md="24" :lg="24" >
        <sharers-chart :sharer-data="sharers" />
      </el-col>


      <el-col v-if="showWays" :md="24" :lg="showWays ? 24 : 0">
        <ways-table :sharer-data="sharers" />
      </el-col>

  </el-row>
</div>
</template>

<script>

import PostMixins from '@/mixins/PostMixins'

import SharersChart from '@/components/dashboard/charts/SharersChart'
import WaysTable from '@/components/dashboard/sharers/WaysTable'

export default {
  mixins: [PostMixins],

  components: {
    SharersChart,
    WaysTable
  },

  props: {

    showWays: {
      type: Boolean,
      default: true
    },

    selectedYear: {
      type: Number,
      default: null
    }

  },



  watch: {
    selectedYear: function (value) {
      this.thisYear = value
      this.fetchData('report/occupancy/' + (this.thisYear ? this.thisYear : ''), this.sharerData, 'Occupancy stats')
    }
  },


  methods: {

    sharerData (data) {
      this.sharers = data
    }

  },



  data () {

    return {
      thisYear: this.selectedYear,
      sharers: []
    }

  },

  created () {
    this.fetchData('report/occupancy/' + (this.thisYear ? this.thisYear : ''), this.sharerData, 'Occupancy stats')
  }
}
</script>

<style>
.dash-heading {
  font-size: 3em;
  color: lightgrey;
  padding-top: 0.852em;
  margin-bottom: 0.528em;
  border-bottom: 1px solid lightgrey}
</style>
